import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  tree = 1,
  night,
  list,
}
export enum AnchorTypeEnum {
  qualifier = 1,
  track,
  knockouts,
}
// 本次活动会投放发的地区
export const areaChinese = {
  '0': '中东',
  '1': '印尼',
  '5': '泰国',
  '2': '越南',
  '6': '印度',
}
// 获取基础配置信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27711861
export const ch_config = createAsyncThunk(
  'ch_config',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<InitialStateType, 'tab_id' | 'send_rank_id' | 'receive_rank_id'>
      >
    >(
      '/live/activity/ch_config',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 圣诞节活动任务列表和奖励列表 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27710700
export const ch_job_list = createAsyncThunk(
  'ch_job_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'job_list'
          | 'item_list'
          | 'star_gift_list'
          | 'count_down'
          | 'progress'
          | 'progress_total'
        >
      >
    >(
      '/live/activity/ch_job_list',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 圣诞节活动房间信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27710780

export const ch_night_room_reward = createAsyncThunk(
  'ch_night_room_reward',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'room_list'
          | 'is_in_time'
          | 'time'
          | 'is_have_room'
          | 'count_down'
          | 'progress'
          | 'progress_total'
          | 'my_room_info'
        >
      >
    >(
      '/live/activity/ch_night_room_reward',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 获取圣诞节活动爆奖弹窗信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27712242
// export const ch_night_room_boom_reward = createAsyncThunk(
//   'ch_night_room_boom_reward',
//   async (arg: {room_id: number}, store: any) => {
//     const {deviceinfo} = store.getState().env
//     const {h_m} = deviceinfo
//     const resp = await http.post<
//       HiyaRes<Pick<InitialStateType, 'reward_type' | 'coin' | 'status'>>
//     >('/live/activity/ch_night_room_boom_reward', {
//       ...arg,
//       mid: h_m,
//       ...store.getState().env.deviceinfo,
//     })
//     return resp.data.data
//   }
// )

interface HiyaRes<T> {
  ret: number
  data: T
}
interface room_info {
  room_id: number
  name: string
  avartar: string
  zy_id: string
  progress: number
  progress_total: number
}
interface job_info {
  id: number
  name: string
  // 任务完成状态（0未完成，1完成）
  status: number
  img: string
}
interface item_info {
  id: number
  // type = 1代表灯，type = 2代表礼物
  type: number
  //  灯是否亮起来的状态（type = 1 的时候 0没亮起来，1亮起来了）
  // (type =2 的时候，0为未完成，1为已完成可领取，2为已完成已领取）
  status: number
  // type = 1的时候不给图片，type = 2 的时候给奖励图片
  img: string
}
interface star_info {
  id: number
  img: string
  // （0未领取，1已领取）
  status: number
  date: string
}
interface InitialStateType {
  // ab_id(1是点亮圣诞树tab，2是奇妙圣诞夜）
  tab_id?: number
  send_rank_id?: number
  receive_rank_id?: number
  // 圣诞节活动房间信息
  room_list?: Array<room_info>
  room_count_down?: number
  room_progress?: number
  room_progress_total?: number
  is_in_time?: boolean
  time?: string
  is_have_room?: boolean
  my_room_info?: room_info
  //  圣诞节活动任务列表和奖励列表
  job_list?: Array<job_info>
  item_list?: Array<item_info>
  star_gift_list?: Array<star_info>
  is_final_star_light?: boolean
  count_down?: number
  progress?: number
  progress_total?: number
}
const initialState: InitialStateType = {}
export const Xmas2021Slice = createSlice({
  name: 'Xmas2021',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // builder.addCase(yup_stage_list.fulfilled, (state, action) => {
    //   const {list, ...rest} = action.payload
    //   // 防止数组返回null，直接重置成[]
    //   const ret = {
    //     schedule_list: list || [],
    //   }
    //   Object.assign(state, ret, rest)
    // })
    builder.addCase(ch_config.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(ch_job_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(ch_night_room_reward.fulfilled, (state, action) => {
      const {room_list, count_down, progress, progress_total, ...rest} =
        action.payload
      // 防止数组返回null，直接重置成[]
      const ret = {
        room_list: room_list || [],
        room_count_down: count_down || 0,
        room_progress: progress,
        room_progress_total: progress_total,
      }
      Object.assign(state, ret, rest)
    })
  },
})
export default Xmas2021Slice.reducer
